// assets/js/conditions/events.js

import { SELECTORS } from './selectors';
import { State } from './state';
import { getRowElements } from './dom';
import { openModal, closeModal, collectModalData } from './modal';
import {
	updateConditionRow,
	addEmptyConditionRow,
	removeConditionRow,
	isConditionSet,
} from './condition-row';
import { ajaxAction } from './ajax';
import { toggleButtonState, setHookName } from './ui';
import { getActiveContext } from './dom';

const $ = jQuery;

export function bindEvents($, ajax = {}) {
	const { ajaxurl, nonce } = ajax;

	// Open modal
	$(document).on('click', SELECTORS.openButton, function (e) {
		e.preventDefault();

		const postId = $(this).data('post-id');
		openModal(postId, ajax);
	});

	// Close modal
	$(document).on(
		'click',
		`${SELECTORS.cancelButton}, ${SELECTORS.backdrop}`,
		function () {
			closeModal();
		}
	);

	// Save
	$(document).on('click', SELECTORS.saveButton, async function (e) {
		e.preventDefault();

		const payload = collectModalData();

		if (!payload) {
			return;
		}

		const saved = await ajaxAction(
			$,
			ajaxurl,
			nonce,
			'snap_blocks_save_conditions',
			payload,
			'post'
		);

		if (saved?.success) {
			State.set(State.currentPostId, saved.data);
			toggleButtonState(payload.post_id, true);
			closeModal();
		}
	});

	// Reset
	$(document).on('click', SELECTORS.resetButton, async function (e) {
		e.preventDefault();

		const payload = collectModalData();

		const postId = payload?.post_id;

		if (!postId) {
			return;
		}

		const deleted = await ajaxAction(
			$,
			ajaxurl,
			nonce,
			'snap_blocks_delete_conditions',
			{ post_id: postId },
			'post'
		);

		if (deleted?.success) {
			State.remove(State.currentPostId);
			toggleButtonState(postId, false);
			closeModal();
		}
	});

	// Condition type change (single handler, no duplicates)
	$(document).on('change', SELECTORS.conditionType, function () {
		const $row = $(this).closest(SELECTORS.row);
		const el = getRowElements($row);

		updateConditionRow($row, {}, ajax);

		const canDuplicate = isConditionSet($row);

		el.duplicate.prop('disabled', !canDuplicate);
	});

	// Add new condition (global button)
	$(document).on('click', SELECTORS.btnAdd, function () {
		addEmptyConditionRow();
	});

	// Remove row
	$(document).on('click', SELECTORS.btnRemove, function () {
		const $row = $(this).closest(SELECTORS.row);
		removeConditionRow($row);
	});

	// Switch context
	$(document).on('click', SELECTORS.contextSelect, function () {
		$(SELECTORS.context).removeClass('active');
		$(`${SELECTORS.context}[data-id="${$(this).val()}"]`).addClass(
			'active'
		);
	});

	$(document).on('change', SELECTORS.hook, function (e) {
		setHookName(getActiveContext());
	});
}
